module.exports = "https://web-assets.ifttt.com/packs/media/access_applet_card/info-drawer-bullet-control-8a1657e1.svg";